import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const Title = styled.h2`
  font-size: var(--fz-title);
  margin-bottom: 20px;
  color: var(--teal);

  @media (max-width: 768px) {
    font-size: 28px;
    text-align: center;
  }
`;

export const Paragraph = styled.p`
  font-size: var(--fz-xl);
  line-height: 1.6;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const TechList = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, minmax(140px, 200px));
  gap: 10px;
  padding: 0;
  list-style: none;
  margin-bottom: 15px;

  li {
    font-size: var(--fz-md);
    position: relative;
    padding-left: 20px;

    &:before {
      content: "▹";
      position: absolute;
      left: 0;
      color: var(--teal);
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 12px;
  }
`;

export const Links = styled.a`
  color: var(--teal);
  text-decoration: none;
  font-weight: 600;
`;
